import { CircularProgress } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";
import Scroll from "react-scroll";

import { DragDropContext, Droppable } from "@hello-pangea/dnd";
import AuditSearchRow from "./AuditSearchRow";

const AuditSearchResults = (props) => {
    const {
        activeTab,
        comps,
        handleDragEnd,
        loadingSearch,
        searchCleared,
        searchRun,
        toggleCompAuditFlag,
        viewDocument,
    } = props;

    let Element = Scroll.Element;

    const onDragEnd = (results) => {
        const { destination, source } = results;
        if (!destination) return;
        if (destination.droppableId === source.droppableId && destination.index === source.index) return;
        console.log("ActiveTab", activeTab);
        handleDragEnd(results, comps, activeTab);
    };

    return (
        <React.Fragment>
            {!searchCleared && Object.keys(comps).length !== 0 ? (
                loadingSearch ? null : (
                    <Element style={{ height: "600px", overflow: "scroll" }}>
                        <DragDropContext onDragEnd={onDragEnd}>
                            <Droppable droppableId="droppable" style={{ maxWidth: "100%" }}>
                                {(provided) => {
                                    return (
                                        <div {...provided.droppableProps} ref={provided.innerRef}>
                                            {comps.map((comp, i) => {
                                                return (
                                                    <AuditSearchRow
                                                        toggleCompAuditFlag={toggleCompAuditFlag}
                                                        viewDocument={viewDocument}
                                                        comp={comp}
                                                        i={i}
                                                    />
                                                );
                                            })}
                                            {provided.placeholder}
                                        </div>
                                    );
                                }}
                            </Droppable>
                        </DragDropContext>
                    </Element>
                )
            ) : null}

            <div style={{ flex: "1 1 auto", justifyContent: "center" }}>
                {loadingSearch ? (
                    <AlternateContent>
                        <CircularProgress color="primary" />
                    </AlternateContent>
                ) : Object.keys(comps).length === 0 ? (
                    searchRun && !searchCleared ? (
                        <AlternateContent>Nothing to Show</AlternateContent>
                    ) : (
                        <AlternateContent>Please apply search criteria</AlternateContent>
                    )
                ) : (
                    ""
                )}
            </div>
        </React.Fragment>
    );
};

const AlternateContent = styled("div")(() => ({
    margin: "auto",
    textAlign: "center",
    marginTop: "6em",
    marginBottom: "6em",
    color: "rgba(0, 0, 0, 0.30)",
    fontSize: "20px",
}));

export default AuditSearchResults;
